import { sessionResource } from '@/api'
import router from '@/router'

const currentUser = JSON.parse(localStorage.getItem('user'))
const lastEmail = JSON.parse(localStorage.getItem('lastEmail'))

const initialState = currentUser
  ? { loggedIn: true, lastEmail, currentUser }
  : { loggedIn: false, lastEmail, currentUser: null }

const state = initialState

const getters = {
  currentUser: (state) => {
    return state.currentUser
  }
}

const actions = {
  login ({ commit }, { email, password }) {
    sessionResource.login(email, password).then(user => {
      commit('LOGIN_SUCCESS', user)
      router.push('/')
    }).catch(err => {
      commit('LOGIN_FAIL', err)
    })
  },

  logout ({ commit }) {
    sessionResource.logout()
    commit('LOGOUT')
    router.push('/login')
  },

  rememberMe ({ commit }, email) {
    commit('REMEMBER_ME', email)
  }
}

const mutations = {
  LOGIN_SUCCESS (state, user) {
    state.loggedIn = true
    state.currentUser = user
  },

  LOGIN_FAIL (state) {
    state.loggedIn = false
    state.currentUser = null
  },

  LOGOUT (state) {
    state.loggedIn = false
    state.currentUser = null
  },

  REMEMBER_ME (state, email) {
    state.lastEmail = email
  }
}

export default {
  namespaced: true, state, getters, actions, mutations
}
